import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';

import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import MuiSwitch from '@material-ui/core/Switch';

import MuiGrid from '@material-ui/core/Grid';

import ViewWrapper from 'views/ViewWrapper';
import TableReportInvoices from 'components/TableReportInvoices';

const styles = theme => ({
  vCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
  toggleLabel: {
    marginRight: 0,
  },
  startLabel: {
    marginRight: theme.spacing(1),
  },
  endLabel: {
    marginLeft: theme.spacing(0.5),
  },
});

const ReportInvoices = ({ ...props }) => {
  const { classes, history, editing, match } = props;

  const queryParams = new URLSearchParams(window.location.search);
  const page = queryParams.get('page');
  const [showUnapproved, setShowUnapproved] = useState(true);

  const handleReportViewToggle = e => {
    setShowUnapproved(e.target.checked);
  };

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          {editing ? (
            <>
              <MuiTypography className={classes.title} variant="h5">
                Edit Invoice
              </MuiTypography>
            </>
          ) : (
            <>
              <MuiTypography className={classes.title} variant="h5">
                Report Invoices
              </MuiTypography>
              {
                <div className={classes.actionRow}>
                  {/* <MuiButton
                  size="small"
                  variant="contained"
                  className={classes.actionButton}
                  startIcon={<MuiAddIcon />}
                >
                  Create
                </MuiButton> */}
                  <div className={classes.vCenter}></div>
                  <div>
                    <span className={classes.startLabel}>Approved or Archived</span>
                    <MuiFormControlLabel
                      className={classes.toggleLabel}
                      control={
                        <MuiSwitch
                          checked={showUnapproved}
                          onChange={handleReportViewToggle}
                          name="showUnapproved"
                          inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                      }
                    />
                    <span className={classes.endLabel}>Not Approved</span>
                  </div>
                </div>
              }
              <TableReportInvoices showUnapproved={showUnapproved} page={page} />
            </>
          )}
        </MuiPaper>
      </MuiGrid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(ReportInvoices);
